import React, { memo } from "react";
import { connect } from "react-redux";
import PropTypes, { number } from "prop-types";
import clsx from "clsx";
import FlagIcon from "@material-ui/icons/Flag";
import style from "./style.module.scss";
import statusStyle from "../style.module.scss";
import { selectImageId } from "redux/image/selectors";
import { getParameterByName } from "helpers";
import { BenchmarkStart } from "icons";
import IntlMessage from "../../helpers/IntlMessage";

/**
 * Mapping from status value to tag config.
 * Reuses the same pattern as STATUS_BUTTON_CONFIG in ButtonGroupV2.
 */
const STATUS_TAG_CONFIG = {
  new: {
    labelId: "common.unassigned",
    className: statusStyle.status_new,
  },
  assigned: {
    labelId: "common.assigned",
    className: statusStyle.status_assigned,
  },
  in_review: {
    labelId: "common.in_review",
    className: statusStyle.status_in_review,
  },
  in_admin_review: {
    labelId: "common.in_admin_review",
    className: statusStyle.status_in_admin_review,
  },
  submitted: {
    labelId: "common.submit",
    className: statusStyle.status_submitted,
  },
  approved: {
    labelId: "common.approve",
    className: statusStyle.status_approved,
  },
  doublecheck: {
    labelId: "common.doublecheck",
    className: statusStyle.status_doublecheck,
  },
  reopen: {
    labelId: "common.reopen",
    className: statusStyle.status_reopen,
  },
  reopened_reviewer: {
    labelId: "common.reopened_reviewer",
    className: statusStyle.status_reopened_reviewer,
  },
  declined: {
    labelId: "common.decline",
    className: statusStyle.status_declined,
  },
  skipped: {
    labelId: "common.skip",
    className: statusStyle.status_skipped,
  },
};

function ImageContainer({
  issue,
  id,
  url,
  status,
  showStatus,
  handlePickImage,
  index,
  currImageId,
  qualityData = 15,
  rotation,
  onLoad,
}) {
  const imageClassName = clsx({
    [style.imageContainer]: true,
    [style.selectedImg]: currImageId === id,
  });
  const isViewResult = getParameterByName("isViewResult");
  const displayQualityData =
    qualityData === 100 ? (
      <span className={style.benchmarkIcon}>
        <BenchmarkStart />
      </span>
    ) : (
      <div className={style.benchmarkWrapper}>{qualityData}%</div>
    );

  const statusConfig = status ? STATUS_TAG_CONFIG[status] : null;

  return (
    <div
      data-id={id}
      className={imageClassName}
      index={index}
      id={`imageContainer_${id}`}
    >
      {issue && issue.total !== 0 && (
        <div className={style.issueWrapper}>
          <FlagIcon
            color={issue.status ? "error" : "primary"}
            fontSize="small"
          />
          <span style={{ whiteSpace: "nowrap", marginLeft: 2 }}>
            {issue.open} / {issue.total}
          </span>
        </div>
      )}
      {showStatus && statusConfig && (
        <span className={`${style.statusTag} ${statusConfig.className}`}>
          <IntlMessage id={statusConfig.labelId} />
        </span>
      )}
      {isViewResult && displayQualityData}
      <img
        data-id={id}
        index={index}
        onClick={handlePickImage}
        onLoad={onLoad}
        src={url}
        loading="lazy"
        className={style.previewImage}
        style={{
          backgroundImage: `url(${url})`,
          transform: `rotate(${(rotation - 1) * 90}deg)`,
        }}
      />
    </div>
  );
}

ImageContainer.propTypes = {
  issue: PropTypes.object,
  status: PropTypes.string,
  showStatus: PropTypes.bool,
  id: PropTypes.string,
  handlePickImage: PropTypes.func,
  index: PropTypes.number,
  currImageId: PropTypes.string,
  url: PropTypes.string,
  qualityData: PropTypes.number,
  rotation: number,
  onLoad: PropTypes.func,
};

const mapStateToProps = (state) => ({
  currImageId: selectImageId(state),
});

export default memo(connect(mapStateToProps)(ImageContainer));
